export default __webpack_public_path__ + "static/media/lifespanRange.8b39e0ac.svg";